import { Group, Text, ActionIcon, Autocomplete } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";



export const ProfessionalSearchInput = ({onClickOption, redirectOnClear = false, initialSearchValue}: {onClickOption: (search: string) => void, redirectOnClear: boolean, initialSearchValue?: string}) => {


     const onRemoveSearch = (search: string) => {
        const updatedSearches = recentSearches.filter(s => s !== search);
        setRecentSearches(updatedSearches);
        localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
    }
    const [recentSearches, setRecentSearches] = useState<string[]>(localStorage.getItem('recentSearches') ? JSON.parse(localStorage.getItem('recentSearches') || '[]') : []);
    const [searchText, setSearchText] = useState(initialSearchValue);

    const onClearSearch = () => {
        setSearchText(undefined);
        if(redirectOnClear) {
            onClickOption('*');
        }
    }

    const lastSearchTextRef = useRef(searchText);

    useEffect(() => {
        const previousSearchText = lastSearchTextRef.current;
        const previousHadValue = Boolean(previousSearchText?.trim());
        const currentIsEmpty = searchText?.trim() === '';

        if (redirectOnClear && previousHadValue && currentIsEmpty) {
            onClickOption('*');
        }

        lastSearchTextRef.current = searchText;
    }, [searchText, redirectOnClear, onClickOption])

    return (
        <Autocomplete 
            placeholder="Search..." 
            leftSection={<IconSearch />} 
            w='100%' 
            size="md" 
            radius='xs' 
            data={[{group: 'Recent Searches', items: recentSearches}]} 
            value={searchText} 
            onChange={setSearchText} 
            maxDropdownHeight={350}
            clearable
            onClear={onClearSearch}
            onKeyDown={(event) => {
            if (event.key === 'Enter' && searchText?.trim()) {
                onClickOption(searchText?.trim());
            }
            }}
            renderOption={({ option }) => {
            return (
                <RecentSearchOption searchOption={option.value} onRemove={onRemoveSearch} onSelect={onClickOption} />
            );
            }} />
    )
}



export const RecentSearchOption = ({searchOption, onRemove, onSelect}: {searchOption: string, onRemove: (search: string) => void, onSelect: (value: string) => void}) => {

    const handleRemoveClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        onRemove(searchOption);
    };

    return (
        <Group justify="space-between" w='100%' onClick={() => onSelect(searchOption)}>
            <Text truncate maw='80%'>{searchOption}</Text>
            <ActionIcon variant="subtle" size="lg" color="black" onClick={handleRemoveClick}>
                <IconX  size={25} />
            </ActionIcon>
        </Group>
    )
}
